import Axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

import i18n from './lib/i18n'
import router from './router'
import initStore from './store/store'

import App from './App.vue'

Axios.defaults.headers.common['Accept-Language'] = navigator.languages.slice(0, 10).map((m, index) => `${m}` + (index === 0 ? '' : `;q=${(10 - index) / 10}`)).join(',')

Vue.config.productionTip = false

Vue.use(Vuex)
const store = initStore()

store.dispatch('session/init')

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
